import { render } from "./Credit.vue?vue&type=template&id=54c40063&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "@/css/layerPop.scss?vue&type=style&index=0&id=54c40063&scoped=true&lang=scss"
import "./Credit.vue?vue&type=style&index=1&id=54c40063&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c40063"]])

export default __exports__